import React from 'react';
import { NamePath } from 'antd/lib/form/interface';
import { FilterBar2Value } from '../types';
import { useWatch, FormInstance, FormItem, TreeSelect } from 'components';
import { Translations } from '../filter-bar-2';

export interface FilterContentSelectProps {
	name: NamePath;
	values?: FilterBar2Value[];
	placeholder?: string;
	className?: string;
	translations: Translations & { selectAllTagText?: string };
	onChange?: (value: any) => void;
	form: FormInstance;
}

export const FilterContentTreeSelect = ({
	name,
	values,
	placeholder,
	className,
	translations,
	onChange,
	form
}: FilterContentSelectProps) => {
	const treeValue = useWatch(name, form);

	return (
		<FormItem name={name}>
			<TreeSelect
				allowSelectAll
				emptyAsAll
				className={className}
				selectAllText={translations.selectAll}
				placeholder={placeholder}
				value={treeValue}
				treeData={values as FilterBar2Value[]}
				onChange={onChange}
				selectAllTagText={translations.selectAllTagText}
			/>
		</FormItem>
	);
};
